import type { CommonOptions } from "@shared/ui";
import type { ProductRequisitionTime } from "../types";

export const PRODUCT_REQUISITION_TIME: CommonOptions<ProductRequisitionTime> = [
	{ value: "IMMEDIETLY", label: "Azonnal" },
	{ value: "TWO_THREE_MONTHS", label: "2-3 hónap múlva" },
	{ value: "FOUR_SIX_MONTHS", label: "4-6 hónap múlva" },
	{ value: "TBD", label: "Még bizonytalan" },
];
